const items = [
  { icon: "ri-restaurant-2-line", label: "30 Yıllık Mutfak Tecrübesi" },
  { icon: "ri-time-line", label: "Günlük Hazırlanan Yemekler" },
  { icon: "ri-truck-line", label: "Planlı Sıcak Teslim" },
  { icon: "ri-shield-check-line", label: "Belgeli Üretim" },
  { icon: "ri-verified-badge-line", label: "ETBİS Kayıtlı İşletme" },
];

export default function TrustStrip() {
  return (
    <section className="bg-primary-500">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 py-6">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-background-50/15 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-background-50 dark:text-foreground-950 text-lg`}></i>
              </div>
              <span className="text-sm font-semibold text-background-50 dark:text-foreground-950 leading-snug">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}